






























import { Component, Vue } from "vue-property-decorator";
import SubmitResetButtonGroop from "../buttons/submit-reset-button-groop.vue";
import StandartModal from "@/components/app/standart-modal.vue";
@Component({ components: { StandartModal, submit: SubmitResetButtonGroop } })
export default class PromotionalCode extends Vue {
  code = "";

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("code", this.code);
  }

  onReset(): void {
    this.code = "";
  }
}
